import React from 'react';
import PropTypes from 'prop-types';

import { TranslatedCopy } from '../../../intl/TranslatedCopy';

import { Button, InputContainer } from '../../../components';
import TextInput from '~COMPONENTS/formInputs/TextInput';

const OrderReturnsPageSearch = ({ updateSearchTerm, selectAllProducts, searchTerm, showSelectAll }) => (
  <div className='orderReturns__searchContainer pt6-sm pt2-md flex-container center u-full-width'>
    <div className='orderReturns__search mt-4-sm mt-2-md u-full-width flex-container column space-between align-center'>
      <div className='u-full-width prl5-sm pl5-md pr10-md pl0-xl'>
        <InputContainer
          label={new TranslatedCopy({ id: 'orderreturns.search' }).toString()}
          extraClassName='search-input'
          isSearch
        >
          <TextInput
            type='text'
            autoComplete='off'
            name='orderReturns__search_textinput'
            onChange={updateSearchTerm}
            value={searchTerm}
          />
        </InputContainer>
      </div>
      <div className='u-full-width mt-2-sm mb4-sm mb2-md mb0-lg mt0-lg mr4-md flex-container prl5-sm'>
        {showSelectAll && (
          <Button
            extraClassName='orderReturns__search_button body-4 text-color-secondary flx-jc-sm-fe flx-jc-md-fs'
            onClick={selectAllProducts}
            textLink
            matchCase
          >
            <TranslatedCopy id='orderreturns.addAllProducts' />
          </Button>
        )}
      </div>
    </div>
  </div>
);

OrderReturnsPageSearch.propTypes = {
  updateSearchTerm: PropTypes.func.isRequired,
  selectAllProducts: PropTypes.func.isRequired,
  searchTerm: PropTypes.string.isRequired,
  showSelectAll: PropTypes.bool.isRequired
};

export default OrderReturnsPageSearch;
